import React, { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";

const ViewPlanningDetails = (props) => {

    useEffect(() => {
    }, []);

    const handleOpenEdit = () => {
        console.log("open edit");
        console.log(props)
        props.agGridReact.props.getPlanningDetails(props.data)
    };

    return (
        <>
            <Button
                onClick={handleOpenEdit}
                disabled={props?.data?.status && (props.data.status != 'Created' && props.data.status != 'Received' && props.data.status != 'In Progress' && props.data.status != 'Approved') ? true : false}
                basic
                size="mini"
                type="button"
                icon
            >
                {" "}
                <img src="assets/img/planning.svg" style={{ height: "15px" }} />
            </Button>
        </>
    );
}

export default ViewPlanningDetails;
